import { render, staticRenderFns } from "./InvoiceInfoModal.vue?vue&type=template&id=35bb362e&"
import script from "./InvoiceInfoModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports